export default __webpack_public_path__ + "static/media/errormsg.6d77d0f8.png";